module.exports = __webpack_public_path__ + "img/1.dbf96c78.svg";